export default __webpack_public_path__ + "static/media/dragonLogo.38d6d71c.png";